module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABR0lEQVQokXXSP0uVYRjH8c95aGxoiJSGQiJqMCEcagkHMQghgqCajCB+4F5tEa2d3Xjusd5BtISCEg31BgKHSJpMmo5RBOHT4H3i4VC/7frzvf5wXYOu60Ap5RJe4hj2cIBpjHA/yZaqpgIP8B4buJBkNskc5vAWm6WUh2No0LbtArZwNcl6LbICSV5Ue7EWvJzkw6Bt2128SXK3lHIC6/hdi/7AcpJRKWUNy7jS4CjGrRdwkGQ+yTzO4k6NPcVxXG/wKcleDbxOcrGOdBP7eFdH/YrPOHdET0l+VmAVa1hK8tGEGpypu/Q1wo0kG2NHKWUKM9hu8B3DCWgfvyZ8T/ANrxrcxkopZamXMI1TvS6LWMWtJF8GXdeNjzvEczxLslOTZ/AY9/AoyRAG/3mjXYdvdNI/3ugvVMHTuIbzFdp2ePid/nJ/AHYVhEifiHEyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/question.png
// module id = /yge
// module chunks = 32